import { render, staticRenderFns } from "./PopupBaseDetail.vue?vue&type=template&id=11e38fd8&"
import script from "./PopupBaseDetail.vue?vue&type=script&lang=js&"
export * from "./PopupBaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./PopupBaseDetail.vue?vue&type=style&index=0&id=11e38fd8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports